import { BasicCommand } from "../../../../common/services/cqs/BasicCommand";
import { IAtgardPrimaryKey } from "../atgard/AtgardBaseCommand";

export abstract class GeometryBaseCommand extends BasicCommand<GeometryBaseCommand> {
    guid: string;
    virkeskopskontraktGuid?: string;
    virkeskopsatgardGuid?: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "karta";

    get primaryKey(): IGeometryPrimaryKey {
        return {
            atgardGuid: this.virkeskopsatgardGuid || null,
            kontraktGuid: this.virkeskopskontraktGuid || null,
            guid: this.guid
        };
    }
    constructor($type, commandType) {
        super($type, GeometryBaseCommand.$groupKey, commandType);
    }
}

export interface IGeometryPrimaryKey extends IAtgardPrimaryKey {
    guid: string;
}
